import classes from './procenaVrednostiTiketa.module.css'
import classesK from '../kalkulatori.module.css'
import { useEffect, useState } from 'react'
import add from '../images/add.svg'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'

const ProcenaVrednostiTiketa = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      serie1: {
        ticket: ['', '', ''],
      },
      percent: [''],
    },
    results: ['', '', ''],
  })

  const clearFields = () => {
    setData({
      values: {
        serie1: {
          ticket: ['', '', ''],
        },
        percent: [''],
      },
      results: ['', '', ''],
    })
    setShowInputArea(true)
    setSeries([{ id: 1 }])
  }

  const [series, setSeries] = useState([{ id: 1 }])

  const addSeries = () => {
    setSeries((prevSeries) => {
      const newSeries = [...prevSeries, { id: prevSeries.length + 1 }]
      setData((prevData) => {
        const newSerieKey = `serie${newSeries.length}`
        return {
          ...prevData,
          values: {
            ...prevData.values,
            [newSerieKey]: {
              ticket: ['', '', ''],
            },
          },
          results: {
            ...prevData.results,
            [`${newSerieKey}Results`]: ['-', '-', '-'],
          },
        }
      })
      return newSeries
    })
  }

  const calculateAll = () => {
    const percent = parseFloat(data.values.percent[0]) || 0

    // Get all series keys dynamically
    const seriesKeys = Object.keys(data.values).filter((key) =>
      key.startsWith('serie')
    )

    // Extract and parse valid odds
    const odds = seriesKeys
      .map((key) => {
        const ticket = data.values[key]?.ticket?.[2]
        const parsed = parseFloat(ticket)
        return isNaN(parsed) ? null : parsed
      })
      .filter((odd) => odd) // Filter out nulls

    console.log(odds)

    if (percent) {
      let v62 = parseFloat(percent)

      let z117 = 0

      for (let i = 0; i < odds.length; i++) {
        if (odds[i]) {
          z117++
        }
      }

      let p117 = z117

      let n117 = 0

      for (let i = 0; i < odds.length; i++) {
        if (odds[i]) {
          n117 = n117 + parseFloat(odds[i])
        }
      }

      let q117 = v62 ? v62 / 100 : 0

      let q116 = parseFloat(p117 / n117)

      let q119 = q116 - q117

      let avgPercentOdds = q119

      let u74 = avgPercentOdds

      let avgOdd = 1 / u74

      let q122 = q119 * p117

      setData((prevData) => {
        return {
          ...prevData,
          results: [
            avgOdd.toFixed(2),
            (avgPercentOdds * 100).toFixed(2),
            q122.toFixed(2) + ` / ${series.length}`,
          ],
        }
      })
    }
  }

  useEffect(() => {
    calculateAll()
  }, [data.values])

  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }

  useEffect(() => {
    const firstSeries = data.values.serie1.ticket
    const allFieldsHaveValue = firstSeries.every(
      (value, index) => value !== '' && (index !== 2 || value > 0)
    )
    console.log(
      'First series:',
      firstSeries,
      'All fields have value:',
      allFieldsHaveValue
    )

    setDisabled(!allFieldsHaveValue)
  }, [data.values])

  useEffect(() => {
    console.log(showInputArea)
  }, [showInputArea])

  return (
    <div className={classesK.container}>
      <InfoBar
        calculatorType={`Procena vrednosti tiketa`}
        onRefresh={clearFields}
      />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled}>
            {showInputArea ? 'Prikaži rezultate' : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Prosečna marža kladionice
              </div>
              <div
                className={`${classes.seriesContainer} ${classes.seriesContainerOne}`}
              >
                <div className={`${classesK.calcButton} ${classes.calcButton}`}>
                  Upiši od 3% do 5%
                </div>
                <div
                  className={`${classesK.oddsContainer} ${classes.oddsContainerOne}`}
                >
                  <span>Upiši br. % od 3 do 5</span>
                  <input
                    type='number'
                    value={data?.values?.percent || ''}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)

                      setData((prevData) => ({
                        ...prevData,
                        values: {
                          ...prevData.values,
                          percent: [value],
                        },
                      }))
                    }}
                  />
                </div>
              </div>

              <div className={classesK.sectionTitle}>Tvoj tiket</div>
              {series.map((serie) => (
                <>
                  <div key={serie.id} className={classes.seriesContainer}>
                    <div
                      className={`${classesK.calcButton} ${classes.calcButton}`}
                    >
                      Par br. {serie.id}
                    </div>
                    <div className={classes.seriesValues}>
                      <div className={classes.oddsContainer}>
                        <div className={classesK.oddsContainer}>
                          <span>Upiši imena timova</span>
                          <input
                            type='text'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[0] || ''
                            }
                            onChange={(e) => {
                              const value = e.target.value

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      value,
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[1],
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[2],
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                        <div className={classesK.oddsContainer}>
                          <span>IGRA</span>
                          <input
                            type='text'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[1] || ''
                            }
                            onChange={(e) => {
                              const value = e.target.value

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[0],
                                      value,
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[2],
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                        <div className={classesK.oddsContainer}>
                          <span>KVOTA</span>
                          <input
                            type='number'
                            min='0'
                            value={
                              data?.values[`serie${serie.id}`]?.ticket[2] || ''
                            }
                            onChange={(e) => {
                              const value = parseFloat(e.target.value)

                              setData((prevData) => ({
                                ...prevData,
                                values: {
                                  ...prevData.values,
                                  [`serie${serie.id}`]: {
                                    ...prevData.values[`serie${serie.id}`],
                                    ticket: [
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[0],
                                      prevData.values[`serie${serie.id}`]
                                        .ticket[1],
                                      value,
                                    ],
                                  },
                                },
                              }))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ))}
              {series.length < 25 && (
                <div className={classesK.addMore}>
                  <button onClick={addSeries} className={classesK.addButton}>
                    <img src={add} height={18} width={18} alt='image' />
                    Dodaj još jednu seriju
                  </button>
                </div>
              )}
            </div>
          </>
        )}
        {!showInputArea && (
          <div className={classes.resultsWrapper}>
            <ResultsSection
              title={`Predikcija prolaznosti na tiketu`}
              subtitle={`Obračunati podaci`}
              names={[
                'Srednja kvota tiketa',
                'Procenat srednje kvote',
                'Prosečan broj prolaznih parova',
              ]}
              results={[
                data.results[0] ? data.results[0] : '-',
                data.results[1] ? `${data.results[1]}%` : '-',
                data.results[2] ? data.results[2] : '-',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProcenaVrednostiTiketa
